import React from 'react';
import { isArray } from 'lodash';
import { getInteractionWrapper } from './utils/getInteractionWrapper.js';
import './utils/combineMappers.js';

const withInteraction = (element, interactions, context) => {
  var _a, _b;
  const { config } = context;
  if (!((_b = (_a = config.PREVIEW) == null ? void 0 : _a.contentInteractionMappers) == null ? void 0 : _b.length) || !config.PREVIEW.onPreviewExpand || !isArray(interactions)) {
    return element;
  }
  const BlockInteractionWrapper = getInteractionWrapper({ interactions, context });
  return /* @__PURE__ */ React.createElement(BlockInteractionWrapper, null, element);
};

export { withInteraction };
//# sourceMappingURL=withInteraction.js.map
